export const isLoggedInPage = (pathname: string) => {
  pathname = pathname.toLowerCase();
  return (
    ["/matches", "/profile", "/settings", "/spark"].includes(pathname) ||
    pathname.startsWith("/profile/") ||
    pathname.startsWith("/invite/") ||
    /^\/event\/[^/]+\/(match|spark)$/.test(pathname)
  );
};
